export const OFFER = {
  isHidden: true,
  nickname: 'PRODUCTS.OFFER.nickname',
  icon:'offer'
};
